export default __webpack_public_path__ + "static/media/16.6383935a.png";